/* eslint-disable no-unused-vars */
import axios from "axios";
import humps from "humps";
import { get } from "lodash";

const API_URI = "https://api.tasas-catastro-test.relex.ar";
//const API_URI = "https://api.clippi.site";
// const API_URI = 'http://0.0.0.0:5000'
const API_HELI_PAGOS = "https://sandbox.helipagos.com";

//const path = (url) => `${API_HELI_PAGOS}${url}`;
const path = (api, url) => `${api}${url}`;

// axios.interceptors.request.use((request) => {
//   console.log('Starting Request', JSON.stringify(request, null, 2))
//   return request
// })

function processResponse(response) {
  if (get(response, "data.status", 2) !== 1) {
    throw response.data.desc;
  }
  return humps.camelizeKeys(response.data.result);
}

async function fetch(api, url, config) {
  const { headers, method = "GET", ...rest } = config;

  const options = {
    method,
    headers: {
      ...headers,
    },
    ...rest,
  };

  try {
    return await axios(path(api, url), options);
  } catch (e) {
    const status = get(e, "response.status");
    throw e;
  }
}

export default fetch;
